/**
 * For reference only - comes from the backend and might be changed in future
 */
export enum UserTypeEnum {
  APP = 'app',
  LDAP = 'ldap',
  WS = 'ws',
}
